



























import Vue, { PropType } from "vue";

export interface ITag {
  identifier: string,
  view: string,
  label: string,
  image_url: string,
  color: string,
  state: 'active' | 'default'
}

export default Vue.extend( {
  name    : 'TagSelect',
  props   : {
    value : {
      type     : String as PropType<string>,
      required : true
    },
    tags  : {
      type     : Array as PropType<ITag[]>,
      required : true
    }
  },
  methods : {
    selectTag( tag: any ) {
      this.$emit( 'select', tag );
    }
  },
  computed : {
    cdn(): string {
      return (window as any).cdn;
    }
  }
} );
